(function (app) {
    app.constant("badScheduledTasks",
        [
            "11aaea03-ba9b-48c8-a6f5-cb16096aa204",
            "99b6dfe1-32e2-4ab8-b323-5122aa211332",
            "8a8263aa-8a27-4804-b4a6-7d0a89abe028",
            "963e1085-8d96-45d3-a26c-9a9a0c20cd96",
            "461cac6e-bbe6-4a03-9807-15197007340e"
        ]);
})(window.app); //jshint ignore:line